/* eslint-disable */
import { produce } from "immer";
import {
  ACCOUNT_PATCH_FAILURE,
  ACCOUNT_PATCH_SUCCESS,
  ACCOUNT_PATCH_START,
} from "../actions/types";

const accountPatch = (
  state = {
    fetching: false,
    data: [],
    error: null,
  },
  action,
) => {
  switch (action.type) {
    case ACCOUNT_PATCH_START:
      return produce(state, (draft) => {
        draft.fetching = true;
      });
    case ACCOUNT_PATCH_SUCCESS:
      return produce(state, (draft) => {
        draft.fetching = true;
        draft.data = action.data;
        draft.fetching = false;
      });
    case ACCOUNT_PATCH_FAILURE:
      return produce(state, (draft) => {
        draft.fetching = false;
        draft.error = action.error;
      });
    default:
      return state;
  }
};

export default accountPatch;
